<template>
  <div>
    <v-list nav dense>
      <!-- Botón INICIO (siempre primero) -->
      <v-list-item link router to="/home" class="list" active-class="white black--text">
        <v-list-item-action>
          <v-icon>mdi-home</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            {{ $t('Inicio') || 'Inicio' }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <!-- Áreas Deportivas -->
      <v-list-group prepend-icon="mdi-dumbbell" no-action color="white" class="menu-group">
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>{{ $t('Areas') || 'Áreas Deportivas' }}</v-list-item-title>
          </v-list-item-content>
        </template>

        <!-- Check-in directo a su área -->
        <v-list-item
          v-if="teacherArea"
          link
          router
          :to="`/sports-area/${teacherArea.idArea}/checkin`"
          :disabled="!teacherArea.idArea"
          class="list"
          active-class="white black--text"
        >
          <v-list-item-action>
            <v-icon>mdi-account-check</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('Panel') || 'Check-in' }}: {{ teacherArea.areaName }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- Mis Áreas -->
        <v-list-item
          link
          router
          to="/teacher/my-areas"
          class="list"
          active-class="white black--text"
        >
          <v-list-item-action>
            <v-icon>mdi-map-marker</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('Mis Áreas') || 'Mis Áreas' }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </v-list>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import axios from 'axios'
import store from '@/store'

export default {
  name: 'teacher-menu',
  computed: {
    ...mapGetters(['getProfile']),
    ...mapState(['language'])
  },
  data: () => ({
    teacherArea: null,
    loadingArea: false
  }),
  created () {
    this.loadTeacherArea()
  },
  methods: {
    async loadTeacherArea () {
      this.loadingArea = true
      try {
        const config = {
          method: 'get',
          url: 'https://clubtest.intrare.app/staff/my-areas/',
          headers: {
            'Content-Type': 'application/json',
            'Accept-Language': this.language || 'es',
            'authorization': 'Token ' + store.getters.getToken
          }
        }

        const response = await axios(config)

        // Handle single area or array
        let area = Array.isArray(response.data) ? response.data[0] : response.data

        if (area) {
          this.teacherArea = area
        }
      } catch (error) {
        console.error('Error loading teacher area:', error)
      } finally {
        this.loadingArea = false
      }
    }
  }
}
</script>

<style scoped>
</style>
